import { Box, Button } from '@chakra-ui/react';
import React, { useState } from 'react';
import { MorePanelStyle } from './style';

type Props = {
  children: React.ReactNode;
  maxHeight?: number;
};

const isEnglish = window.__LANG__ === 'en';

function MorePanel({ children, maxHeight }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <MorePanelStyle>
      <article style={{maxHeight: open ? '100000px' : `${maxHeight}px`}}>{children}</article>
      <Box textAlign="center" pt="6">
        <Button fontSize="2xl" color="b.lg" colorScheme="wh" onClick={() => setOpen(!open)}>
          {
            open ? isEnglish ? 'Close' : '닫기' : isEnglish ? 'View All' : '전체보기'
          }
        </Button>
      </Box>
    </MorePanelStyle>
  );
}

MorePanel.defaultProps = {
};

export default MorePanel;
